(function () {
    'use strict';

    angular
        .module('app.newMentions')
        .factory('newMentionsService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope) {
                var service = {};

                function checkResponse(data) {
                    return data;
                }

                function getMessage(data) {
                    if (data) {
                        return data.message;
                    }
                    return false;
                }

                function handleRequest(url, method, params, loader) {
                    var deferred = $q.defer();

                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader
                    }

                    $http(req)
                        .success(function (data) {
                            var dataRes = angular.fromJson(data);

                            if (checkResponse(dataRes)) {
                                deferred.resolve(dataRes);
                            } else {
                                deferred.reject(getMessage(dataRes));
                            }
                        })
                        .error(function (error) {
                            deferred.reject(error);
                        });

                    return deferred.promise;
                }

                function getNewMentions(loader) {
                    var url_getNewMentions = $rootScope.apiUrl + 'mention/getNewMentions';
                    return handleRequest(url_getNewMentions, 'POST', null, loader);
                }


                function getDuplicatedMentions(keyword, type_id, loader) {
                    var url_getNewMentions = $rootScope.apiUrl + 'mention/getDuplicatedMentions?keyword=' + keyword + "&keyword_type_id=" + type_id;
                    return handleRequest(url_getNewMentions, 'GET', null, loader);
                }

                function setNotApprovedMention(mention_id, params, loader) {
                    var url_setNotApprovedMention = $rootScope.apiUrl + 'mention/setNotApprovedMention/' + mention_id;
                    return handleRequest(url_setNotApprovedMention, 'POST', params, loader);
                }

                function setApprovedMention(mention_id, params, loader) {
                    var url_setApprovedMention = $rootScope.apiUrl + 'mention/setApprovedMention/' + mention_id;
                    return handleRequest(url_setApprovedMention, 'POST', params, loader);
                }

                function checkNewMention(mention, language_id, status, loader) {
                    var url_checkNewMention = $rootScope.apiUrl + "mention/checkNewMention?mention=" + mention + "&languageId=" + language_id + "&status=" + status;
                    return handleRequest(url_checkNewMention, 'GET', null, loader);
                }

                service.getNewMentions = getNewMentions;
                service.getDuplicatedMentions = getDuplicatedMentions;
                service.setNotApprovedMention = setNotApprovedMention;
                service.setApprovedMention = setApprovedMention;
                service.checkNewMention = checkNewMention;
                return service;
            }
        ]);
})();
